<!-- BottomNav Template - Feature: 012-desktop-mobile-shells -->
<!-- patientCount$ subscription triggers re-render when patients load -->
@if (patientCount$ | async; as _patientCount) {}
<nav class="bottom-nav" role="navigation" [attr.aria-label]="'SHELL.BOTTOM_NAVIGATION' | translate">
  <div class="bottom-nav__container">
    @for (item of navItems; track item.route) {
      <a [routerLink]="item.route"
         routerLinkActive="active"
         class="bottom-nav__tab"
         [attr.aria-label]="getLabelKey(item) | translate">
        <span class="bottom-nav__icon-wrap">
          <mat-icon class="bottom-nav__icon">{{ item.icon }}</mat-icon>
          @if (showsUnreadBadge(item) && (unreadCount$ | async); as unreadCount) {
            <span
              class="bottom-nav__badge"
              [attr.aria-label]="'NAV.MESSAGES_UNREAD_BADGE' | translate:{ count: unreadCount }">
              {{ badgeLabel(unreadCount) }}
            </span>
          }
        </span>
        <span class="bottom-nav__label">{{ getLabelKey(item) | translate }}</span>
      </a>
    }
  </div>
</nav>
